import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import ButtonsIncDec from '../ButtonsIncDec';
import SlotStep from './SlotStep';
import { TbMoodConfuzed, TbPhotoX } from 'react-icons/tb';
import Button from '../../Form/Button';
import { useCartContext } from '../../../Contexts/CartContext';
import { useLoginContext } from '../../../Contexts/LoginContext';
import ButtonOpenStoreCounter from '../ButtonOpenStoreCounter';
import DOMPurify from 'dompurify';
import Img from '../Img';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import CartService from '../../../Services/CartService';
import { useStoreContext } from '../../../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import { PRODUCT_TYPE_COMPOSITE, PRODUCT_TYPE_SIMPLE } from '../../../Utils/Constants/Product';
import ProductPrice from './ProductPrice';
import Badge from '../Badge';
import { HiXMark } from 'react-icons/hi2';
import AddProductObservation from './AddProductObservation';
import Scrollbars from 'react-custom-scrollbars-2';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { isNewProductOnCatalog } from '../../../Utils/Helpers';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import ButtonAddProduct from './ButtonAddProduct';
import { useProductsHook } from '../../../Hooks/ProductsHook';
import { useCartHook } from '../../../Hooks/CartHook';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';

interface AddProductProps {
    product: any;
    category: any;
}

const AddProduct = ({
    product,
    category,
}: AddProductProps) => {

const { setShowAddProduct } = useAddProductContext();
const { token } = useLoginContext();
const { addCartTempInConference, setAddProductCartTemp, cartTemp, cartDisplay, currentSteps, setCurrentSteps, requiredStepsValid, allStepsExtrasValid, allStepsIsExtras, disabledButtonAddProduct, setDisabledButtonAddProduct, getPriceTotalSelectedComplements, cartFinished, cartConference, currentCart, loadingCurrentCart, loadingUpdateQuantity } = useCartContext();
const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery } = useOrderTypeContext();
const [height] = useState('45vh');
const [fixedTitle, setFixedTitle] = useState(false);
const fixedTitleRef = useRef<HTMLDivElement | null>(null);
const description = DOMPurify.sanitize(product.description);
const [currentProduct, setCurrentProduct] = useState<any>(product);
const [currentPrice, setCurrentPrice] = useState<number>(0);
const [loadingSteps, setLoadingSteps] = useState(product.type === PRODUCT_TYPE_COMPOSITE);
const { currentStore, cashier } = useStoreContext();
const { isMobile } = useLayoutContext();

const { sendProducts } = useProductsHook();
const { currentCartNotFound } = useCartHook();

const [showShadow, setShowShadow] = useState(false);
const handleScrollFrame = (values: any) => {

const { scrollTop, scrollHeight, clientHeight } = values;
    // Verifica se o scroll está no início ou no fim para controlar a sombra
    if (scrollTop >= 0 && (scrollTop + clientHeight + 2) < scrollHeight) {
        setShowShadow(true);
    } else {
        setShowShadow(false);
    }

    if (fixedTitleRef.current) {
        const updatePosition = () => {
            if (fixedTitleRef.current) {
                const posFixedTitle = fixedTitleRef.current.getBoundingClientRect();
                setFixedTitle(posFixedTitle.top <= 0);
            }
        };

        updatePosition();
        window.addEventListener("scroll", updatePosition);
        window.addEventListener("resize", updatePosition);

        return () => {
            window.removeEventListener("scroll", updatePosition);
            window.removeEventListener("resize", updatePosition);
        };
    }
}

useEffect(() => {
    //* Exibição da sombra dos itens quando houver scroll
    const boxScroll = document.getElementById('boxScroll');
    const scrollContent = document.getElementById('scrollContent');

    if (boxScroll && scrollContent) {
        const boxScrollHeight = boxScroll.getBoundingClientRect().height;
        const scrollContentHeight = scrollContent.getBoundingClientRect().height;
        setShowShadow(scrollContentHeight > boxScrollHeight)
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps])

const handleCancel = () => {
    setShowAddProduct(false)
    setTimeout(() => { //* timeout only for layout
        setCurrentSteps([]);
    }, 200);
}

const handleAdd = () => {
    if (!isStoreCounter && !currentCart?.cart_id) {
        currentCartNotFound();
        return;
    }

    //* Produtos em destaque não posso category.id
    const categoryId = category.id ? category.id : currentProduct.categories[0].id;

    setAddProductCartTemp({...currentProduct, currentCategoryId: categoryId});
}

useEffect(() => {
    if (cartTemp.length > 0) {
            addCartTempInConference();
        if (isStoreCounter) {
            setShowAddProduct(false);
        }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartTemp]);

useEffect(() => {
    if (!isStoreCounter && cartConference.length > 0) {
        cartConference.forEach((item: any) => {
            const payload = {
                order_type: Number(getOrderTypeIdByName(orderType)),
                product_id: item.id,
                quantity: item.quantity,
                observation: item.observation ?? '',
                ...(isDelivery && {shipping_value: currentStore.shipping_value}),
                ...(item.steps && item.steps.length > 0 && { steps: item.steps })
            }
            sendProducts(currentCart.cart_id, payload);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartConference]);

const handleObservation = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newObservation = event.target.value
    setCurrentProduct({...currentProduct, observation: newObservation})
};

useEffect(() => {
    setCurrentProduct({...currentProduct, quantity: 1})
    setCurrentSteps([]);
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

const handleUpdateProduct = (quantity: number) => {
    setCurrentProduct({...currentProduct, quantity: quantity})
}

useEffect(() => {
    const getStepsAndComplements = async () => {
        const payload = {
            store_id: currentStore.id,
            product_id: product.id,
            order_type: Number(getOrderTypeIdByName(orderType)),
        }
        try {
            const cartService = new CartService(orderType, token);
            const getSteps = await cartService.stepsAndComplements(payload);
            if (getSteps) {
                setCurrentSteps(getSteps.product.product_composite_steps);
            }
        } catch (error: any) {
            setCurrentSteps([]);
        } finally {
            setLoadingSteps(false);
        }
    }
    if (product.type === PRODUCT_TYPE_COMPOSITE) {
        getStepsAndComplements();
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [getOrderTypeIdByName, orderType, product.id, currentStore.id, token])

useEffect(() => {
    if (currentSteps) {
        setDisabledButtonAddProduct(
            loadingSteps
                || (product.type === PRODUCT_TYPE_COMPOSITE && !allStepsIsExtras() && !requiredStepsValid())
                || (product.type === PRODUCT_TYPE_COMPOSITE && allStepsIsExtras() && !allStepsExtrasValid())
                || loadingCurrentCart
                || loadingUpdateQuantity
        );

    if (currentSteps.length > 0) {
        setCurrentPrice(getPriceTotalSelectedComplements())
        setCurrentProduct((prevProduct: any) => ({
            ...prevProduct,
            price: getPriceTotalSelectedComplements()
        }));
    } else {
        setCurrentPrice(product.price)
        setCurrentProduct((prevProduct: any) => ({
            ...prevProduct,
            price: product.price
        }));
      }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps, loadingCurrentCart, loadingUpdateQuantity]);

return (
    <section className="flex flex-col justify-between h-full max-h-dvh">

        <div className='relative h-full min-h-24' id="boxScroll">
            <Scrollbars
                autoHeight={!isMobile}
                autoHide={true}
                autoHeightMin={isMobile ? "100%" : ""}
                autoHeightMax={isMobile ? "100dvh" : ""}
                className='min-h-full'
                onScrollFrame={handleScrollFrame}
            >
            <div id='scrollContent' className='flex flex-col gap-4 w-full md:h-auto md:max-h-[80vh]' >
                <div className='flex h-full gap-4'>

                    <div className='h-full md:flex w-full'>
                        <div className={`inline md:flex md:flex-col h-full md:top-0 ${product.type === PRODUCT_TYPE_COMPOSITE ? 'md:self-start md:w-3/6 md:sticky' : 'w-full'}`}>
                            {product.photos?.medium
                                ?   <div id="boxImage" className="relative md:hidden z-10 sticky top-0 block w-full bg-no-repeat bg-fixed bg-cover bg-center bg-gray-50" style={{height, backgroundImage: `url('${product.photos.medium}')`}}></div>
                                :   <Img src={product.photos?.medium} fallback={
                                        <div className='md:hidden flex items-center justify-center w-full h-full bg-gray-50' style={{height}}>
                                            <TbPhotoX size={50} className='text-gray-200' /></div>
                                        } alt={product.name} className="w-full"
                                    />
                            }

                            {/* Title Top (desktop) */}
                            <div className='hidden md:flex md:flex-col md:flex-grow w-full text-left'>
                                <div className='flex h-[45vh] max-h-fit justify-center p-2 overflow-hidden'>

                                    {product.type === PRODUCT_TYPE_COMPOSITE &&
                                        <div className={`
                                            flex items-center w-full justify-center md:p-1.5 rounded h-64
                                            ${!product.photos.medium && 'bg-no-repeat bg-cover bg-center bg-gray-50 min-h-[25vh]'}
                                        `}>
                                            {!product.photos.medium && <TbPhotoX size={50} className='text-gray-200' />}
                                            {product.photos.medium && <Img src={product.photos?.medium} alt={product.name} className="
                                            w-full h-full rounded-md object-cover transition-width ease-in-out duration-200
                                            " />}
                                        </div>
                                    }

                                    {product.type === PRODUCT_TYPE_SIMPLE &&
                                        <div className='
                                        flex items-center w-full justify-center md:p-1.5
                                        min-h-[45vh]
                                        rounded
                                        bg-no-repeat bg-cover bg-center
                                        bg-gray-50
                                        '
                                        style={{height, backgroundImage: `url('${product.photos.medium}')`}}
                                        >
                                            {!product.photos.medium && <TbPhotoX size={50} className='text-gray-200' />}
                                        </div>
                                    }

                                </div>

                                <div className="flex flex-col w-full flex-1 h-auto gap-2 p-4 pb-2 text-left">
                                    <h2 className='text-2xl font-bold text-custom-primary'>
                                        {product.name}
                                    </h2>

                                    {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                    {(isNewProductOnCatalog(product.tags) && !product.from_price) && <BadgeNewProduct className='flex-inline self-start rounded -mr-0.5' /> }

                                    {/* PRODUCT SALE  */}
                                    {product.from_price > 0 && <BadgeProductSale className='flex-inline self-start rounded -mr-0.5' />}

                                    <div className='text-sm text-nowrap'>
                                        <ProductPrice product={product} />
                                    </div>

                                    <div className='text-sm leading-5 text-gray-500 mb-2' dangerouslySetInnerHTML={{ __html: description }} />

                                    {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                        <div className='pt-2'>
                                        <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } />
                                        </div>
                                    }

                                </div>
                            </div>

                        </div>


                        <div className={`md:w-full bg-white sticky z-20 ${product.type !== PRODUCT_TYPE_COMPOSITE && 'md:hidden'}`}>
                            <section className='relative p-1 pt-2 md:p-4 md:pl-0 h-full flex flex-col'>

                                {/* Header/Title Side (mobile) */}
                                <header className='md:hidden' ref={fixedTitleRef}>
                                    <div className='grid gap-1 w-full text-left p-2'>
                                        <h2 className={
                                        `transition-all ease-in-out duration-200
                                        flex gap-1 items-center text-gray-700
                                        font-extrabold
                                        ${fixedTitle ? 'fixed top-0 h-16 text-2xl left-0 z-50 py-4 pl-4 pr-6 w-full bg-white ring-1 ring-gray-100 cursor-pointer' : 'text-2xl'}`
                                        }
                                        onClick={() => fixedTitle ? handleCancel() : false}
                                        >
                                            <span className={`text-custom-primary ${fixedTitle && 'leading-5'}`}>{product.name}</span>
                                            {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                            {(fixedTitle && (isNewProductOnCatalog(product.tags) && !product.from_price)) && <BadgeNewProduct className='absolute top-0 right-2 rounded-b' /> }
                                            {(fixedTitle && product.from_price > 0) && <BadgeProductSale className='absolute top-0 right-2 rounded-b' />}
                                        </h2>
                                        <div className='flex items-center gap-1 text-nowrap'>
                                            <ProductPrice product={product} />

                                            <div>
                                                {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                                {(isNewProductOnCatalog(product.tags) && !product.from_price) && <BadgeNewProduct className='rounded' /> }

                                                {/* PRODUCT SALE  */}
                                                {product.from_price > 0 && <BadgeProductSale className='rounded' />}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='text-left leading-5 text-gray-500 p-2 pt-0 mb-2 md:mb-0' dangerouslySetInnerHTML={{ __html: description }} />

                                    {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                        <div className='p-2 pt-0 mb-2 md:mb-0'>
                                            <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } />
                                        </div>
                                    }

                                </header>

                                {product.type === PRODUCT_TYPE_COMPOSITE &&
                                    <div className={`flex flex-col gap-4 md:gap-6 md:h-full ${loadingSteps && 'overflow-hidden'}`}>

                                        {loadingSteps
                                            ?
                                                <div className="flex items-center md:justify-center gap-1 min-h-full text-sm text-gray-500 p-3 pt-6">
                                                <ImSpinner8 className="animate-spin" />
                                                <span>Carregando opções</span>
                                                </div>
                                            :
                                            currentSteps.length === 0
                                                ?   <div className='h-full flex items-center justify-center gap-1 text-sm text-gray-500'><TbMoodConfuzed /> <span>Nenhum produto encontrado</span></div>
                                                :   currentSteps.map((step: any, index: number) => <SlotStep product={product} step={step} key={index} />)
                                        }

                                        <BoxContentEndScrollbars show={!loadingSteps && currentSteps.length > 0} message='Fim dos produtos' />

                                    </div>
                                }

                            </section>
                        </div>

                    </div>

                </div>
            </div>

        </Scrollbars>
    </div>



      <div className={`mt-2 w-full h-2 bg-white shadow-reverse-md transition ${showShadow ? 'opacity-100' : 'opacity-0'}`}></div>

      {/* Footer buttons */}
      <div className={`flex gap-2 w-full p-4 pt-2 md:justify-end text-sm ${!cashier && 'justify-end'}`}>

        {(isStoreCounter && cashier) &&
            <>
                {!cartDisplay ?
                    <ButtonOpenStoreCounter
                        label={cartFinished
                                ? <div className='flex items-center gap-1 w-full justify-between'><Badge type='success' outline className='h-5 ring-2 rounded-full font-extrabold text-sm'>Pago</Badge> Veja seu comprovante</div>
                                : undefined
                        } />
                    :
                    <>
                        <div className='hidden md:block w-2/5' />
                        {/* {(!loadingSteps && (currentSteps.length === 0 || (currentSteps.length > 0 && !allStepsIsExtras() ))) &&  */}
                        <ButtonsIncDec disabled={loadingSteps} onInc={handleUpdateProduct} onDec={handleUpdateProduct} className='md:w-auto min-w-28' />
                        {/* } */}
                        <ButtonAddProduct
                        currentProduct={currentProduct}
                        currentPrice={currentPrice}
                        disabledButtonAddProduct={disabledButtonAddProduct}
                        onHandleAdd={handleAdd}
                        />
                    </>
                }
            </>
        }

        {!isStoreCounter &&
            <>
                {/* {(!loadingSteps && (currentSteps.length === 0 || (currentSteps.length > 0 && !allStepsIsExtras() ))) &&  */}
                <ButtonsIncDec disabled={loadingSteps} onInc={handleUpdateProduct} onDec={handleUpdateProduct} className='md:w-auto min-w-28' />
                {/* } */}

                <ButtonAddProduct
                currentProduct={currentProduct}
                currentPrice={currentPrice}
                disabledButtonAddProduct={disabledButtonAddProduct}
                onHandleAdd={handleAdd}
                />
            </>
        }

        <Button onClick={handleCancel} className='w-11 h-11'><div><HiXMark size={20} /></div></Button>

      </div>

    </section>
  )
}

export default AddProduct;